module.exports = __webpack_public_path__ + "img/ic_adults.d018c8ec.svg";